"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyForms = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const EmptyFormsSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    clipPath: "url(#empty-forms__a)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#CCD4FF",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#A5AEFF",
      d: "M12.202 6.8c.22 0 .4.177.4.4v.2H15c.222 0 .401.18.401.4v11a.4.4 0 0 1-.401.4H6.602a.4.4 0 0 1-.4-.4v-11c0-.221.179-.4.4-.4h2.4v-.2a.4.4 0 0 1 .398-.4z",
      opacity: 0.35
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#171717",
      d: "M7.4 6.6c0-.221.18-.4.402-.4h8.397c.222 0 .401.18.401.4v11a.4.4 0 0 1-.4.4H7.801a.4.4 0 0 1-.402-.4z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M7.8 17.4c0 .11.09.2.2.2h8.001a.2.2 0 0 0 .2-.2V6.8a.2.2 0 0 0-.2-.2h-8a.2.2 0 0 0-.2.2z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#767676",
      d: "M14.3 13.6a.1.1 0 0 1 .1.1l-.002.017a.1.1 0 0 1-.099.083H9.7a.1.1 0 1 1 0-.2zm0-1.6a.1.1 0 0 1 .1.1l-.002.017a.1.1 0 0 1-.099.083H9.7a.1.1 0 1 1 0-.2zm0-1.6a.1.1 0 0 1 .1.1l-.002.017a.1.1 0 0 1-.099.083H9.7a.1.1 0 1 1 0-.2z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#171717",
      d: "M10.201 6a.4.4 0 0 1 .4-.4h2.801c.22 0 .4.177.4.4v.8a.4.4 0 0 1-.4.4H10.6a.4.4 0 0 1-.399-.4z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#A5AEFF",
      fillRule: "evenodd",
      d: "M10.803 6a.2.2 0 0 0-.201.201v.397c0 .111.09.202.2.202H13.2a.2.2 0 0 0 .202-.202V6.2A.2.2 0 0 0 13.2 6z",
      clipRule: "evenodd"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "empty-forms__a",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
const EmptyForms = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: EmptyFormsSvg
}));
exports.EmptyForms = EmptyForms;